'use client';

import { c as _c } from "react/compiler-runtime";
import { datadogRum } from '@datadog/browser-rum';
import { getGraphQLClient } from '@repo/data-access/graphql-client';
import { env } from '@repo/platform-env';
import { AFFECTED_FEATURES, IdentityErrorCategory } from '@repo/utils/errors/approvalOddsErrors';
import { useQuery } from '@tanstack/react-query';
import cookies from 'js-cookie';
import * as v from 'valibot';
import { IDENTITY_QUERY, type IdentityResponse } from '../lib/identity/identityService';
import { IdentitySchema } from '../lib/identity/schema';
import { useIsHydrated } from '../lib/internal/hooks';
export function useIdentity() {
  const $ = _c(13);
  const isHydrated = useIsHydrated();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["identity"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: t0,
      queryFn: _temp,
      refetchOnMount: false,
      enabled: cookies.get("id_token") !== undefined
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data,
    isLoading,
    error,
    refetch,
    isRefetching
  } = useQuery(t1);
  const isLoggedIn = !!data?.rawIdentity?.data;
  const isNWPlusMember = !!data?.rawIdentity?.data?.identity?.is_nerdwallet_plus_member;
  const email = data?.rawIdentity?.data?.identity?.email;
  const sheaId = data?.rawIdentity?.data?.identity?.shea_id;
  const identityId = data?.rawIdentity?.data?.identity?.id;
  const identity = data?.identity;
  if (error) {
    datadogRum.addError(error, {
      message: "Error fetching identity data",
      errorCategory: IdentityErrorCategory.FETCH_ERROR,
      affectsFeatures: `${AFFECTED_FEATURES.APPROVAL_ODDS},${AFFECTED_FEATURES.CREDIT_SCORE}`
    });
  }
  const t2 = isLoading || !isHydrated;
  let t3;
  if ($[2] !== email || $[3] !== error || $[4] !== identity || $[5] !== identityId || $[6] !== isLoggedIn || $[7] !== isNWPlusMember || $[8] !== isRefetching || $[9] !== refetch || $[10] !== sheaId || $[11] !== t2) {
    t3 = {
      error,
      identity,
      identityId,
      isLoggedIn,
      isNWPlusMember,
      email,
      loading: t2,
      refetch,
      refetching: isRefetching,
      sheaId
    };
    $[2] = email;
    $[3] = error;
    $[4] = identity;
    $[5] = identityId;
    $[6] = isLoggedIn;
    $[7] = isNWPlusMember;
    $[8] = isRefetching;
    $[9] = refetch;
    $[10] = sheaId;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
async function _temp() {
  datadogRum.addAction("Identity fetch started");
  const csrfToken = cookies.get("csrf_token");
  const gqlClient = getGraphQLClient({
    platform: "web",
    url: env.NEXT_PUBLIC_SUPERGRAPH_URL,
    headers: {
      ...(csrfToken ? {
        "X-Header-CSRF-Token": csrfToken
      } : {})
    }
  });
  const response = await gqlClient.query(IDENTITY_QUERY);
  return v.parse(IdentitySchema, response.data);
}